// src/pages/install-app/install-app.styles.ts
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

// Simple floating animation for the iOS illustration
export const float = keyframes`
  0% { transform: translateY(0px); opacity: 0; }
  20% { opacity: 1; }
  50% { transform: translateY(-6px); }
  100% { transform: translateY(0px); }
`;

// Fade-in for the steps text
export const fadeInUp = keyframes`
  0% { opacity: 0; transform: translateY(8px); }
  100% { opacity: 1; transform: translateY(0); }
`;

export const Title = styled.h1`
  margin: 0;
  font-family: Custora;
  font-weight: 400;
  font-style: normal;
  font-size: 28px;
  line-height: 140%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color: #e9ecf5;
`;

export const Subtitle = styled.p`
  margin: 0;
  font-family: 'Inter';
  font-weight: 400;
  font-style: normal;
  font-size: 18px;
  line-height: 140%;
  letter-spacing: 0;
  text-align: center;
  vertical-align: middle;
  color: #b7bdcb;
`;

export const InstallButton = styled.button`
  width: 100%;
  border-radius: 12px;
  border: none;
  outline: none;
  cursor: pointer;
  padding: 8px;
  background: #5e84ed;
  font-family:
    'Inter',
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0;
  vertical-align: middle;
  color: #ffffff;
  height: 48px;
  transition:
    background 0.15s ease,
    transform 0.1s ease,
    box-shadow 0.15s ease;

  &:hover {
    background: #6f92f0;
    box-shadow: 0 8px 24px rgba(94, 132, 237, 0.4);
    transform: translateY(-1px);
  }

  &:active {
    background: #4f74dd;
    box-shadow: 0 4px 16px rgba(94, 132, 237, 0.3);
    transform: translateY(0);
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
    box-shadow: none;
    transform: none;
  }
`;

export const InstallDescription = styled.span`
  color: #B7BDCB;
  font-size: 14px;
  font-family: Inter;
  font-weight: 400;
  line-height: 19.60px;
  word-wrap: break-word;
  text-align: center;
`;

// Wrapper for the install button (replacing the inline style div)
export const InstallButtonWrapper = styled.div`
  padding: 0 8px;
`;

export const StepText = styled.div`
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  leading-trim: NONE;
  line-height: 140%;
  letter-spacing: 0px;
  vertical-align: middle;
  color: #b7bdcb;
  line-height: 19.60px;
  word-wrap: break-word;
  display: flex;
  align-items: center;
  gap: 6px;
`;

// DEV overlay
export const DevOverlay = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 16px;
  background: rgba(3, 7, 18, 0.96);
  border-top: 1px solid rgba(148, 163, 184, 0.35);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  z-index: 9999;
  font-family:
    'Inter',
    system-ui,
    -apple-system,
    BlinkMacSystemFont,
    sans-serif;
  font-size: 12px;
  color: #e5e7eb;
`;

export const DevLabel = styled.div`
  font-weight: 500;
  margin-right: 4px;
`;

export const DevButton = styled.button<{ active?: boolean }>`
  border-radius: 999px;
  border: 1px solid ${({ active }) => (active ? '#5e84ed' : 'rgba(148, 163, 184, 0.6)')};
  background: ${({ active }) => (active ? 'rgba(94, 132, 237, 0.18)' : 'transparent')};
  color: #e5e7eb;
  padding: 4px 10px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    border-color: #5e84ed;
  }
`;

export const DevMeta = styled.div`
  margin-left: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  text-align: right;
  opacity: 0.8;
`;

export const DevMetaLine = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const HowToInstall = styled.div`
  font-family: Inter;
  font-weight: 500;
  font-style: Medium;
  font-size: 15px;
  leading-trim: NONE;
  line-height: 140%;
  letter-spacing: 0px;
  text-align: left;
  vertical-align: middle;
  color: #e9ecf5;
`;
